import { styled } from '@linaria/react';
import { useSpring } from 'react-spring';

import useSequence from './use-sequence.hook';
import Label from './Label';
import {
  BaseWrapper,
  Layer,
  Skew,
  BaseElement,
  BaseMargin,
  ChildElement,
  SPRING_CONFIGS,
} from './bits';

function MarginCollapseOpposing() {
  const [stepIndex, step, handlers] = useSequence({
    mode: 'interactive',
  });

  const firstSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : -15}%) scale(${
      stepIndex === 0 ? 1 : 0.925
    })`,
    config: SPRING_CONFIGS[0],
  });

  const secondSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : 15}%)`,
    config: SPRING_CONFIGS[0],
  });

  return (
    <Wrapper {...handlers}>
      <Layer style={{ zIndex: 1, ...secondSpring }}>
        <Skew>
          <ParentMargin />
          <BaseElement>
            <TextWrapper style={{ opacity: stepIndex === 2 ? 1 : 0 }}>
              Parent
            </TextWrapper>
          </BaseElement>
        </Skew>
        <Label
          isVisible={stepIndex === 2}
          style={{
            top: '32%',
            right: '-25%',
          }}
        >
          margin-top: 72px
        </Label>
      </Layer>

      <Layer
        style={{
          top: 48,
          zIndex: 2,
          ...firstSpring,
        }}
      >
        <Skew>
          <ChildMargin />
          <ChildElement>
            <TextWrapper style={{ opacity: stepIndex === 2 ? 1 : 0 }}>
              Child
            </TextWrapper>
          </ChildElement>
        </Skew>
        <Label
          orientation="up"
          isVisible={stepIndex === 2}
          style={{
            top: '-40%',
            left: '-25%',
          }}
        >
          margin-top: 24px
        </Label>
      </Layer>
    </Wrapper>
  );
}

const Wrapper = styled(BaseWrapper)`
  height: 290px;
`;

const TextWrapper = styled.span`
  transition: opacity 500ms;
  display: inline-block;
  padding: 16px;
`;

const ParentMargin = styled(BaseMargin)`
  height: 72px;
`;
const ChildMargin = styled(BaseMargin)`
  height: 24px;
`;

export default MarginCollapseOpposing;
